import { render, staticRenderFns } from "./AddonSubscriptionsTable.vue?vue&type=template&id=22a8aed6&scoped=true"
import script from "./AddonSubscriptionsTable.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AddonSubscriptionsTable.vue?vue&type=script&charset=utf-8&lang=js"
import style0 from "./AddonSubscriptionsTable.vue?vue&type=style&index=0&id=22a8aed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a8aed6",
  null
  
)

export default component.exports